import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import EmailUpdateModalUI from './EmailUpdateModalUI.js'

class EmailUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false,
      email: this.props.account.email || '',
      emailError: null,
    }
  }

  render() {
    return (
      <EmailUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        email={this.state.email}
        onEmailChange={(event) => { this.setState({ email: event.target.value }) }}
        emailError={this.state.emailError}
        setEmailError={(error) => { this.setState({ emailError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    if (this.state.submitted)
      return

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(this.state.email)) {
      this.setState({ emailError: 'Invalid email address' })
      return
    }

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
      emailError: null
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/updateEmail`,
      this.onSubmitCallback,
      {
        email: this.state.email
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response && response.errorList) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response ? response.success : null,
      errorList: errorList,
      submitted: false
    })

    if (!response || (response.errorList && response.errorList.length === 0)) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default EmailUpdateModalSF
